import React from "react";
import { Badge } from "components/ui/badge";
import { Button } from "components/ui/button";
import { Card } from "components/ui/card";
import { motion } from "framer-motion";
import { Calendar, Clock, ArrowRight } from "lucide-react";
import Footer from "./LandingPage/Footer";
import Navbar from "./LandingPage/Navbar";

const Blog = () => {
  const posts = [
    {
      title: "10 Strategies to Boost Social Media Engagement",
      excerpt:
        "Discover proven tactics to increase meaningful interactions and build a loyal community through strategic comment management.",
      category: "Strategy",
      date: "Mar 15, 2024",
      readTime: "5 min read",
      image:
        "https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=800&h=600&fit=crop",
    },
    {
      title: "The Power of Authentic Responses in Social Media",
      excerpt:
        "Learn why genuine, personalized responses to comments can transform your brand reputation and customer loyalty.",
      category: "Best Practices",
      date: "Mar 12, 2024",
      readTime: "7 min read",
      image:
        "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=600&fit=crop",
    },
    {
      title: "How to Handle Negative Comments Like a Pro",
      excerpt:
        "Master the art of turning criticism into opportunity with our comprehensive guide to professional comment management.",
      category: "Guide",
      date: "Mar 10, 2024",
      readTime: "6 min read",
      image:
        "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=800&h=600&fit=crop",
    },
    {
      title: "AI and the Future of Community Management",
      excerpt:
        "Explore how artificial intelligence is revolutionizing the way brands interact with their online communities.",
      category: "Technology",
      date: "Mar 8, 2024",
      readTime: "8 min read",
      image:
        "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&h=600&fit=crop",
    },
    {
      title: "Building Trust Through Consistent Engagement",
      excerpt:
        "Why regular, quality interactions with your audience are the foundation of a successful social media presence.",
      category: "Community",
      date: "Mar 5, 2024",
      readTime: "5 min read",
      image:
        "https://images.unsplash.com/photo-1557804506-669a67965ba0?w=800&h=600&fit=crop",
    },
    {
      title: "Measuring Success: Key Metrics for Comment Engagement",
      excerpt:
        "Understand which metrics matter most when evaluating your comment management strategy and ROI.",
      category: "Analytics",
      date: "Mar 3, 2024",
      readTime: "6 min read",
      image:
        "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=600&fit=crop",
    },
  ];

  return (
    <div className="min-h-screen bg-background">
      <Navbar />

      <section className="pt-32 pb-24">
        <div className="container mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h1 className="text-5xl md:text-6xl font-heading font-bold mb-6 bg-gradient-to-r from-primary to-blue-400 bg-clip-text text-transparent">
              Insights & Resources
            </h1>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              Expert advice on comment management, social media engagement, and
              building meaningful connections with your audience.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
            {posts.map((post, index) => (
              <motion.div
                key={post.title}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
              >
                <Card className="overflow-hidden h-full flex flex-col hover:shadow-glow transition-all duration-300 group">
                  <div className="relative overflow-hidden">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="w-full h-48 object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    <Badge className="absolute top-4 left-4 bg-primary/90 backdrop-blur-sm">
                      {post.category}
                    </Badge>
                  </div>
                  <div className="p-6 flex flex-col flex-grow">
                    <div className="flex items-center gap-4 text-sm text-muted-foreground mb-3">
                      <div className="flex items-center gap-1">
                        <Calendar className="h-4 w-4" />
                        <span>{post.date}</span>
                      </div>
                      <div className="flex items-center gap-1">
                        <Clock className="h-4 w-4" />
                        <span>{post.readTime}</span>
                      </div>
                    </div>
                    <h3 className="text-xl font-heading font-bold mb-3 group-hover:text-primary transition-colors">
                      {post.title}
                    </h3>
                    <p className="text-muted-foreground mb-4 flex-grow">
                      {post.excerpt}
                    </p>
                    <Button
                      variant="ghost"
                      className="w-full justify-between group-hover:text-primary"
                    >
                      Read More
                      <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                    </Button>
                  </div>
                </Card>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Blog;
